// extracted by mini-css-extract-plugin
module.exports = {"customFieldsGrid":"product-custom-fields_customFieldsGrid__otSPV"};